var ERROR_TYPE;
(function (ERROR_TYPE) {
  ERROR_TYPE["SUBMITTED_VIDEO_FAIL"] = "SubmittedVideoFail";
  ERROR_TYPE["SUBMITTED_IMAGE_FAIL"] = "SubmittedImageFail";
  ERROR_TYPE["SUBMITTED_PDF_FAIL"] = "SubmittedPdfFail";
  ERROR_TYPE["SUBMITTED_ATTACHMENT_FAIL"] = "SubmittedAttachmentFail";
  ERROR_TYPE["SAVE_ASSET_FAIL"] = "SaveAssetFail";
  ERROR_TYPE["SUBMITTED_WITHOUT_REQUIRED_FAIL"] = "SubmittedWhitoutRequiredFields";
  ERROR_TYPE["SUBMITTED_SIZE_FAIL"] = "SubmittedSizeFail";
  ERROR_TYPE["REMOVE_ASSET_FAIL"] = "SubmittedRemoveAssetFail";
  ERROR_TYPE["UPLOAD_ASSET_FAIL"] = "UploadAssetFail";
  ERROR_TYPE["MEDIA_FILE_NOT_ALLOWED"] = "UploadCoverExtensionNotAllowed";
})(ERROR_TYPE || (ERROR_TYPE = {}));

export { ERROR_TYPE };
